// Generated by @sgflabs/opticomm-sdk-codegen. Do not edit.
// Run `yarn workspace @sgflabs/opticomm-sdk-codegen generate` after changing a backend route.
import { buildPath } from "../../core/path.js";
export const createStoreDistributorPriceLists = (client) => ({
    /**
     * `GET /store/distributor-price-lists`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @operationId StoreDistributorPriceListsList
     * @source apps/backend/src/api/store/distributor-price-lists/route.ts
     */
    list: (query, headers) => client.fetch("/store/distributor-price-lists", { method: "GET", query, headers }),
    /**
     * `GET /store/distributor-price-lists/:id/products`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @operationId StoreDistributorPriceListsIdProductsRetrieve
     * @source apps/backend/src/api/store/distributor-price-lists/[id]/products/route.ts
     */
    listProducts: (id, query, headers) => client.fetch(buildPath("/store/distributor-price-lists/:id/products", [id]), { method: "GET", query, headers }),
    /**
     * `GET /store/distributor-price-lists/:id`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @operationId StoreDistributorPriceListsIdRetrieve
     * @source apps/backend/src/api/store/distributor-price-lists/[id]/route.ts
     */
    retrieve: (id, query, headers) => client.fetch(buildPath("/store/distributor-price-lists/:id", [id]), { method: "GET", query, headers }),
});
//# sourceMappingURL=distributor-price-lists.js.map